import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getToolbarUtilityClass(slot: string) {
  return generateUtilityClass('O2LinkBox', slot);
}

const productCardClasses = generateUtilityClasses('O2LinkBox', [
  'root',
  'topContent',
  'mainContent',
  'bottomContent',
  'startIcon',
  'endIcon',
  'closeButton',
  'chipWrapper',
  'topContentHover',
  'bottomContentHover',
]);

export default productCardClasses;
